

export function search(searchCriteria) {
    var urlSearchParams = new URLSearchParams(searchCriteria);
    var queryString = urlSearchParams.toString();
    return fetch(`${process.env.REACT_APP_API_URL}/api/search?${queryString}`)
}

export function searchExportLink(searchCriteria) {
    var urlSearchParams = new URLSearchParams(searchCriteria);
    var queryString = urlSearchParams.toString();
    return `${process.env.REACT_APP_API_URL}/api/search/export?${queryString}`;
}

export function getRecording(id) {    
    let url = `${process.env.REACT_APP_API_URL}/api/recordings/${encodeURIComponent(id)}`;
    return fetch(url)
}

export function getSession(id) {    
    let url = `${process.env.REACT_APP_API_URL}/api/sessions/${encodeURIComponent(id)}`;
    return fetch(url)
}

export function getSessionRecordings(id) {    
    let url = `${process.env.REACT_APP_API_URL}/api/sessions/${encodeURIComponent(id)}/recordings`;
    return fetch(url)
}

const RecordingApi = { search, searchExportLink, getRecording, getSession, getSessionRecordings };

export default RecordingApi
